import BaseApi from './BaseApi';

import {
	IInvestSecondaryMarketProps,
	IMakeCounterofferProps,
	PaginationParams,
	SortPaginationParams,
} from 'models';

export class SecondaryMarketApi extends BaseApi {
	constructor() {
		super('/market');
	}

	getAll(params: SortPaginationParams) {
		return this.httpClient.get({
			url: `/list`,
			conditions: { auth: true, version: 'v2' },
			config: { params },
		});
	}

	buy({ id }: IInvestSecondaryMarketProps) {
		return this.httpClient.post({
			url: `/${id}/buy`,
			conditions: { auth: true, version: 'v2' },
		});
	}

	getCounterofferProperties(id: string) {
		return this.httpClient.get({
			url: `/${id}/counter-offer/properties `,
			conditions: { auth: true, version: 'v2' },
		});
	}

	makeCounteroffer({ id, amount }: IMakeCounterofferProps) {
		return this.httpClient.post({
			url: `/${id}/counter-offer`,
			conditions: { auth: true, version: 'v2' },
			body: { amount },
		});
	}

	getCounteroffers(params?: PaginationParams) {
		return this.httpClient.get({
			url: `/counter-offer/seller/list`,
			conditions: { auth: true, version: 'v2' },
			config: { params },
		});
	}

	acceptCounteroffer(id: string) {
		return this.httpClient.patch({
			url: `/counter-offer/${id}/accept`,
			conditions: { auth: true, version: 'v2' },
		});
	}
	rejectCounteroffer(id: string) {
		return this.httpClient.patch({
			url: `/counter-offer/${id}/reject`,
			conditions: { auth: true, version: 'v2' },
		});
	}

	getBuyerCounteroffers(params?: PaginationParams) {
		return this.httpClient.get({
			url: `/counter-offer/buyer/list`,
			conditions: { auth: true, version: 'v2' },
			config: { params },
		});
	}

	cancelCounteroffer(id: string) {
		return this.httpClient.patch({
			url: `/counter-offer/${id}/cancel`,
			conditions: { auth: true, version: 'v2' },
		});
	}
}
export const SecondaryMarketService = new SecondaryMarketApi();
